import React, { useState } from 'react';
import ResponsiveDialog from '../../../../components/Modal/modal';
import { useLang } from '../../../../util/lang';

const ChangeRequestReminderModal = ({ open = false, setOpen, handleDataSave }) => {
    const get = useLang();

    return (
        <ResponsiveDialog
            className="modal"
            modal=""
            title={''}
            open={open}
            handleClose={() => setOpen(false)}
            handleDataSave={handleDataSave}
            submitButton={true}
            submitButtonLabel={get('@global.const.submit')}
            optBtn={undefined}
            maxWidth={'md'}
        >
            {get('@PatientInfo.clinicalSimulation.modal.changeRequestReminderText')}
        </ResponsiveDialog>
    );
};

export default ChangeRequestReminderModal;
